import React, { type PropsWithChildren } from 'react';
import { OrganisationContext } from 'context/index';
import facade from 'context/OrganisationContext/facade';

export const OrganisationContextComponent: React.FC<PropsWithChildren> = ({ children }) => {
   return <OrganisationContext.Provider value={facade.reducedContext$}>{children}</OrganisationContext.Provider>;
};

export default OrganisationContextComponent;
